export default __webpack_public_path__ + "content/cf246e21218cab398b3d274f582ef394.ttf";